"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
require("./styles/ai-hub-loading-state.scss");
/**
 * Reusable AI Hub loading state with a centered spinner and label.
 */
var AiHubLoadingState = function (_a) {
    var label = _a.label, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.isFullScreen, isFullScreen = _c === void 0 ? false : _c;
    var classes = [
        "ws-ai-hub-loading-state",
        isFullScreen ? "ws-ai-hub-loading-state-full-screen" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    return (react_1.default.createElement("div", { className: classes },
        react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.large, label: label })));
};
exports.default = AiHubLoadingState;
